import React from 'react';

import PictureScreen from './PictureScreen';

export const CameraStatus = {
  IDLE: 'IDLE',
  PERMISSION_PENDING: 'PERMISSION_PENDING',
  READY_TO_TAKE_PICTURE: 'READY_TO_TAKE_PICTURE',
};

const CheckinPictureScreen: React.FC = () => {
  return <PictureScreen />;
};

export default CheckinPictureScreen;
